import React, { Fragment, useState, useEffect } from "react";
import Navbar from "../../Components/Navbar";
import SideBar from "./../../Components/Sidebar";
import { Checkbox, Icon, Intent } from "@blueprintjs/core";
import AddNewEntity from "./../../images/addEntity.png";
import SelectArrow from "./../../images/selectArrow.png";
import OpenFolderBlue from "./../../images/openFolderBlue.png";
import CloseFolderBlue from "./../../images/closeFolderBlue.png";
import IndustriesEntityFolder from "./../../images/industriesEntityFolder.png";
import DeleteHcRow from "./../../images/deleteHcRow.png";
import EditHcRow from "./../../images/editHcRow.png";
import CrossPink from "./../../images/crossPink.png";
import AddMileageRateForCustomer from "./addMileageRateForCustomer";
import { GET, DELETE, POST, TenantID, PUT } from "./../dataSaver";
import { fetchEntityDetails } from "../../utils/generalConfig";
import { ErrorToaster, SuccessToaster } from "./../../utils/toaster";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import DeleteConfirmation from "../../Components/DeleteConfirmation";
import { InputGroup } from "@blueprintjs/core";
import style from "./index.module.scss";
import LevelTwoHeader from "../../Components/LevelTwoHeader";
import CommonSwitch from "../../Components/CommonFields/CommonSwitch";
import CommonSelectField from "../../Components/CommonFields/CommonSelectField";
import CommonPurpleCheckBox from "../../Components/CommonFields/CommonPurpleCheckBox";

const GeneralConfigurationForCustomers = () => {
  const [isSelected, setIsSelected] = useState(false);
  const [showAddCompanyDialog, setShowAddCompanyDialog] = useState(false);

  const [isEdit, setIsEdit] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMileageRate, setSelectedMileageRate] = useState({});
  const [entityId, setEntityId] = useState("");
  const [lastUpdatedDate, setLastUpdatedDate] = useState("");
  const [mileageRateData, setMileageRateData] = useState([]);
  const [generalConfig, setGeneralConfig] = useState([]);
  const [vendorDataRequired, setVendorDataRequired] = useState(false);
  const [plannedAbsence, setPlannedAbsence] = useState(false);
  const [unPlannedAbsence, setUnplannedAbsence] = useState(false);
  const [sharePoint, setSharePoint] = useState(false);
  const [externalContractIdLabel, setExternalContractIdLabel] = useState("");
  const [
    timesheetReviewAndApprovalDayLimit,
    setTimesheetReviewAndApprovalDayLimit,
  ] = useState(0);
  const [activityLoggingTimeIntervalInMinutes, setActivityLoggingTimeIntervalInMinutes] = useState("");
  const [timesheetConsultEnabled, setTimesheetConsultEnabled] = useState(false);
  const [sessionTimeoutInMinutes, setSessionTimeoutInMinutes] = useState("");
  const [sessionBufferTimeoutInMinutes, setSessionBufferTimeoutInMinutes] = useState("");
  const [activityCostRoundingScale, setActivityCostRoundingScale] = useState("");
  const [costCenterEnabled, setCostCenterEnabled] = useState(false);
  const [costCenterMappingType, setCostCenterMappingType] = useState("");
  const [isActivityNotesIconNeeded, setIsActivityNotesIconNeeded] = useState(false);
  const [contractedServiceSummaryEnabled, setContractedServiceSummaryEnabled] = useState(false);
  const [authorizationRequestsEnabled, setAuthorizationRequestsEnabled] = useState(false);
  const [departmentNeeded, setDepartmentNeeded] = useState(false);
  const getAddMileageRateDialog = (value) => {
    setShowAddCompanyDialog(value);
  };

  const getIsExpanded = (value) => {
    setIsExpanded(value);
  };

  useEffect(() => {
    const loadGeneralConfig = async () => {
      try {
        const { fetchGeneralConfig } = await import("../../utils/generalConfig");
        const data = await fetchGeneralConfig();
        if (data) {
          console.log("Loaded general config data:", data);
          console.log("externalContractIdLabel from API:", data?.externalContractIdLabel);
          setGeneralConfig(data);
          setVendorDataRequired(data?.vendorExternalSystemInfoRequired);
          setTimesheetReviewAndApprovalDayLimit(data?.timesheetReviewAndApprovalDayLimit);
          setPlannedAbsence(data?.hasPlannedAbsenceConfig);
          setUnplannedAbsence(data?.hasUnPlannedAbsenceConfig);
          setSharePoint(data?.areContractsOnSharepoint);
          setExternalContractIdLabel(data?.externalContractIdLabel || "");
          setToAddress(Array.isArray(data?.toAddress) ? data?.toAddress[0] || "" : data?.toAddress || "");
          setActivityLoggingTimeIntervalInMinutes(data?.activityLoggingTimeIntervalInMinutes || "");
          setTimesheetConsultEnabled(data?.timesheetConsultEnabled || false);
          setSessionTimeoutInMinutes(data?.sessionTimeoutInMinutes ?? "");
          setSessionBufferTimeoutInMinutes(data?.sessionBufferTimeoutInMinutes ?? "");
          setActivityCostRoundingScale(data?.activityCostRoundingScale || "");
          setCostCenterEnabled(data?.costCenterEnabled || false);
          setCostCenterMappingType(data?.costCenterMappingType || "");
          setIsActivityNotesIconNeeded(data?.activityNotesIconNeeded || false);
          setContractedServiceSummaryEnabled(data?.contractedServiceSummaryEnabled || false);
          setAuthorizationRequestsEnabled(data?.authorizationRequestsEnabled || false);
          setDepartmentNeeded(data?.departmentNeeded || false);
        }
      } catch (e) {
        console.error("Error:", e);
      }
    };

    getIndustryData();
    loadGeneralConfig();
  }, []);


  useEffect(() => {
    getMileageRateList();
  }, []);

  useEffect(() => {
    if (entityId !== "" && entityId !== undefined) {
      getLastModifiedDate();
    }
  }, [entityId]);

  const getIndustryData = async () => {
    const entity = await fetchEntityDetails({ tenantId: TenantID });
    setEntityId(entity?.id);
  };

  const getLastModifiedDate = async () => {
    const { data: lastModifiedDate } = await GET(
      `entity-service/referenceList/entity/${entityId}`
    );
    const date = new Date(lastModifiedDate.holidayList?.lastModified);
    setLastUpdatedDate(format(date, "MMM d, yyyy HH:mm"));
  };

  const getMileageRateList = async () => {
    const { data: mileageRateData } = await GET(
      `entity-service/mileageRate?X-tenantID=${TenantID}`
    );
    setMileageRateData(mileageRateData);
  };

  const handleDeleteMileageRate = async (id) => {
    await DELETE(`entity-service/mileageRate/${id}`)
      .then((response) => {
        SuccessToaster("Mileage Rate Deleted Successfully");
        getMileageRateList();
        // getLastModifiedDate();
      })
      .catch((error) => {
        ErrorToaster(error);
      });
  };

  const getShowDeleteConfirmation = (value) => {
    setShowDeleteConfirmation(value);
  };

  const getDeleteConfirmation = (value) => {
    if (value) {
      // handleDeleteMileageRate(mileageId);
    }
  };

  // general config now loaded via cached utility

  const [toAddress, setToAddress] = useState("");

  const handleSave = async () => {
    console.log("externalContractIdLabel before save:", externalContractIdLabel);

    let data = {
      entityId: {
        id: entityId,
      },
      vendorExternalSystemInfoRequired: vendorDataRequired,
      timesheetReviewAndApprovalDayLimit: timesheetReviewAndApprovalDayLimit,
      toAddress: toAddress ? [toAddress] : [],
      externalContractIdLabel: externalContractIdLabel || "",
      hasPlannedAbsenceConfig: plannedAbsence,
      hasUnPlannedAbsenceConfig: unPlannedAbsence,
      areContractsOnSharepoint: sharePoint,
      activityLoggingTimeIntervalInMinutes: activityLoggingTimeIntervalInMinutes ? parseInt(activityLoggingTimeIntervalInMinutes) : 0,
      timesheetConsultEnabled: timesheetConsultEnabled,
      sessionTimeoutInMinutes: sessionTimeoutInMinutes !== "" ? parseInt(sessionTimeoutInMinutes) : 0,
      sessionBufferTimeoutInMinutes: sessionBufferTimeoutInMinutes !== "" ? parseInt(sessionBufferTimeoutInMinutes) : 0,
      activityCostRoundingScale: activityCostRoundingScale || null,
      costCenterEnabled: costCenterEnabled,
      costCenterMappingType: costCenterMappingType || null,
      activityNotesIconNeeded: isActivityNotesIconNeeded,
      contractedServiceSummaryEnabled: contractedServiceSummaryEnabled,
      authorizationRequestsEnabled: authorizationRequestsEnabled,
      departmentNeeded: departmentNeeded,
    };
    console.log("Data being sent:", data);

    const reloadGeneralConfig = async () => {
      try {
        const { fetchGeneralConfig } = await import("../../utils/generalConfig");
        const data = await fetchGeneralConfig({ force: true });
        if (data) {
          console.log("Reloaded general config data after save:", data);
          console.log("externalContractIdLabel after save:", data?.externalContractIdLabel);
          setGeneralConfig(data);
          setVendorDataRequired(data?.vendorExternalSystemInfoRequired);
          setTimesheetReviewAndApprovalDayLimit(data?.timesheetReviewAndApprovalDayLimit);
          setPlannedAbsence(data?.hasPlannedAbsenceConfig);
          setUnplannedAbsence(data?.hasUnPlannedAbsenceConfig);
          setSharePoint(data?.areContractsOnSharepoint);
          setExternalContractIdLabel(data?.externalContractIdLabel || "");
          setToAddress(Array.isArray(data?.toAddress) ? data?.toAddress[0] || "" : data?.toAddress || "");
          setActivityLoggingTimeIntervalInMinutes(data?.activityLoggingTimeIntervalInMinutes || "");
          setTimesheetConsultEnabled(data?.timesheetConsultEnabled || false);
          setSessionTimeoutInMinutes(data?.sessionTimeoutInMinutes ?? "");
          setSessionBufferTimeoutInMinutes(data?.sessionBufferTimeoutInMinutes ?? "");
          setActivityCostRoundingScale(data?.activityCostRoundingScale || "");
          setCostCenterEnabled(data?.costCenterEnabled || false);
          setCostCenterMappingType(data?.costCenterMappingType || "");
          setIsActivityNotesIconNeeded(data?.activityNotesIconNeeded || false);
          setContractedServiceSummaryEnabled(data?.contractedServiceSummaryEnabled || false);
          setAuthorizationRequestsEnabled(data?.authorizationRequestsEnabled || false);
          setDepartmentNeeded(data?.departmentNeeded || false);
        }
      } catch (e) {
        console.error("Error reloading general config:", e);
      }
    };

    if (generalConfig?.entityId?.id === entityId) {
      await PUT(
        `entity-service/generalConfig/${generalConfig?.id}`,
        JSON.stringify(data)
      )
        .then(async (response) => {
          SuccessToaster("Config Updated Successfully");
          await reloadGeneralConfig();
        })
        .catch((error) => {
          ErrorToaster(error);
        });
    } else {
      await POST("entity-service/generalConfig", JSON.stringify(data))
        .then(async (response) => {
          SuccessToaster("Config Added Successfully");
          await reloadGeneralConfig();
        })
        .catch((error) => {
          ErrorToaster(error);
        });
    }
  };

  console.log("vendor data required", vendorDataRequired);

  const getDaysOptions = () => {
    return Array.from({ length: 15 }, (_, i) => {
      const dayValue = i + 1;
      return {
        value: dayValue,
        label: `${dayValue} ${dayValue === 1 ? "Day" : "Days"}`,
      };
    });
  };

  return (
    <Fragment>
      <div>
        <Navbar />
        <div className={style.margin20}>
          <div
            className={`${isExpanded ? style.bigCardGrid : style.smallCardGrid
              }`}
          >
            <div>
              <SideBar isExpanded={isExpanded} getIsExpanded={getIsExpanded}>
                <div></div>
              </SideBar>
            </div>
            <div>
              <LevelTwoHeader
                heading={"GENERAL CONFIGURATION"}
                // updatedTime={`UPDATED ON ${lastUpdatedDate} `}
                path={"/Screens/ReferenceList/customerAdminDashboard"}
                callingFrom={"Customer Admin"}
                needHeader={true}
              />

              <div className={style.marginTop35}>
                <div className={`${style.centreCardStyle} ${style.thinScrollbar}`}>
                  <div className={style.margin20}>
                    <div className={style.customersAdminColumngrid3}>
                      <div></div>
                      <div>
                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Activity Cost Rounding Scale*
                            </div>
                            <div className={style.selectWrapper}>
                              <CommonSelectField
                                className={style.halfWidth}
                                value={activityCostRoundingScale}
                                onChange={(e) => setActivityCostRoundingScale(e.target.value)}
                                valueList={["TWO_DECIMALS", "THREE_DECIMALS"]}
                                labelList={["Two Decimals", "Three Decimals"]}
                                disabledList={[false, false]}
                                firstOptionLabel="Select Rounding Scale"
                                firstOptionValue=""
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Activity Logging Time Interval*
                            </div>
                            <div className={style.selectWrapper}>
                              <CommonSelectField
                                className={style.halfWidth}
                                value={activityLoggingTimeIntervalInMinutes}
                                onChange={(e) => setActivityLoggingTimeIntervalInMinutes(e.target.value)}
                                valueList={[15, 30, 60]}
                                labelList={["15 Minutes", "30 Minutes", "60 Minutes"]}
                                disabledList={[false, false, false]}
                                firstOptionLabel="Select Interval"
                                firstOptionValue=""
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Activity Notes Icon Needed*
                            </div>
                            <div className={style.displayInRow}>
                              <CommonSwitch
                                label={isActivityNotesIconNeeded === true ? "YES" : "NO"}
                                className={`${style.textAlignLeft} ${style.switchFontStyle} ${style.flexLeft}`}
                                onChange={() => setIsActivityNotesIconNeeded(!isActivityNotesIconNeeded)}
                                checked={isActivityNotesIconNeeded}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Are Contract Documents Fetched from Sharepoint?*
                            </div>
                            <div className={style.displayInRow}>
                              <CommonSwitch
                                label={
                                  sharePoint === true ? "YES" : "NO"
                                }
                                className={`${style.textAlignLeft} ${style.switchFontStyle} ${style.flexLeft}`}
                                onChange={() =>
                                  setSharePoint(!sharePoint)
                                }
                                checked={sharePoint}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Authorization Requests Enabled*
                            </div>
                            <div className={style.displayInRow}>
                              <CommonSwitch
                                label={authorizationRequestsEnabled === true ? "YES" : "NO"}
                                className={`${style.textAlignLeft} ${style.switchFontStyle} ${style.flexLeft}`}
                                onChange={() => setAuthorizationRequestsEnabled(!authorizationRequestsEnabled)}
                                checked={authorizationRequestsEnabled}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Certification Language for Accounts Payable*
                            </div>
                            <div className={style.displayInRow}>
                              <InputGroup
                                value={""}
                                className={style.halfWidth}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Certification Language for Approver*
                            </div>
                            <div className={style.displayInRow}>
                              <InputGroup
                                value={""}
                                className={style.halfWidth}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Certification Language for Reviewer*
                            </div>
                            <div className={style.displayInRow}>
                              <InputGroup
                                value={""}
                                className={style.halfWidth}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Contracted Service Summary Enabled*
                            </div>
                            <div className={style.displayInRow}>
                              <CommonSwitch
                                label={contractedServiceSummaryEnabled === true ? "YES" : "NO"}
                                className={`${style.textAlignLeft} ${style.switchFontStyle} ${style.flexLeft}`}
                                onChange={() => setContractedServiceSummaryEnabled(!contractedServiceSummaryEnabled)}
                                checked={contractedServiceSummaryEnabled}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Cost Center Enabled*
                            </div>
                            <div className={style.displayInRow}>
                              <CommonSwitch
                                label={costCenterEnabled === true ? "YES" : "NO"}
                                className={`${style.textAlignLeft} ${style.switchFontStyle} ${style.flexLeft}`}
                                onChange={() => setCostCenterEnabled(!costCenterEnabled)}
                                checked={costCenterEnabled}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Cost Center Mapping Type*
                            </div>
                            <div className={style.selectWrapper}>
                              <CommonSelectField
                                className={style.halfWidth}
                                value={costCenterMappingType}
                                onChange={(e) => setCostCenterMappingType(e.target.value)}
                                valueList={["SITE_ID"]}
                                labelList={["Site ID"]}
                                disabledList={[false]}
                                firstOptionLabel="Select Mapping Type"
                                firstOptionValue=""
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Department Needed*
                            </div>
                            <div className={style.displayInRow}>
                              <CommonSwitch
                                label={departmentNeeded === true ? "YES" : "NO"}
                                className={`${style.textAlignLeft} ${style.switchFontStyle} ${style.flexLeft}`}
                                onChange={() => setDepartmentNeeded(!departmentNeeded)}
                                checked={departmentNeeded}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Email*
                            </div>
                            <div className={style.displayInRow}>
                              <InputGroup
                                value={toAddress}
                                onChange={(e) => setToAddress(e.target.value)}
                                placeholder="Enter email"
                                className={style.halfWidth}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              External Contract Id Label*
                            </div>
                            <div className={style.displayInRow}>
                              <InputGroup
                                value={externalContractIdLabel}
                                onChange={(e) => setExternalContractIdLabel(e.target.value)}
                                placeholder="Enter External Contract Id Label"
                                className={style.halfWidth}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Planned Absence need Approval Workflow*
                            </div>
                            <div className={style.displayInRow}>
                              <CommonSwitch
                                label={
                                  plannedAbsence === true ? "YES" : "NO"
                                }
                                className={`${style.textAlignLeft} ${style.switchFontStyle} ${style.flexLeft}`}
                                onChange={() =>
                                  setPlannedAbsence(!plannedAbsence)
                                }
                                checked={plannedAbsence}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Session Buffer Timeout (Minutes)*
                            </div>
                            <div className={style.displayInRow}>
                              <InputGroup
                                type="number"
                                min={2}
                                value={sessionBufferTimeoutInMinutes}
                                onChange={(e) => setSessionBufferTimeoutInMinutes(e.target.value)}
                                placeholder="Enter session buffer timeout in minutes"
                                className={style.halfWidth}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Session Timeout (Minutes)*
                            </div>
                            <div className={style.displayInRow}>
                              <InputGroup
                                type="number"
                                min={2}
                                value={sessionTimeoutInMinutes}
                                onChange={(e) => setSessionTimeoutInMinutes(e.target.value)}
                                placeholder="Enter session timeout in minutes"
                                className={style.halfWidth}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Timesheet Consult*
                            </div>
                            <div className={style.displayInRow}>
                              <CommonSwitch
                                label={timesheetConsultEnabled === true ? "YES" : "NO"}
                                className={`${style.textAlignLeft} ${style.switchFontStyle} ${style.flexLeft}`}
                                onChange={() => setTimesheetConsultEnabled(!timesheetConsultEnabled)}
                                checked={timesheetConsultEnabled}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Timesheet Review And Approval Day Limit*
                            </div>

                            <div className={style.selectWrapper}>
                              <CommonSelectField
                                className={style.halfWidth}
                                value={timesheetReviewAndApprovalDayLimit}
                                onChange={(e) =>
                                  setTimesheetReviewAndApprovalDayLimit(
                                    e.target.value
                                  )
                                }
                                valueList={getDaysOptions().map(
                                  (opt) => opt.value
                                )}
                                labelList={getDaysOptions().map(
                                  (opt) => opt.label
                                )}
                                disabledList={getDaysOptions().map(
                                  (opt) => false
                                )}
                                firstOptionLabel="Select Days"
                                firstOptionValue=""
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Unplanned Absence need Approval Workflow*
                            </div>
                            <div className={style.displayInRow}>
                              <CommonSwitch
                                label={
                                  unPlannedAbsence === true ? "YES" : "NO"
                                }
                                className={`${style.textAlignLeft} ${style.switchFontStyle} ${style.flexLeft}`}
                                onChange={() =>
                                  setUnplannedAbsence(!unPlannedAbsence)
                                }
                                checked={unPlannedAbsence}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Vendor External System Info Required*
                            </div>
                            <div className={style.displayInRow}>
                              <CommonSwitch
                                label={
                                  vendorDataRequired === true ? "YES" : "NO"
                                }
                                className={`${style.textAlignLeft} ${style.switchFontStyle} ${style.flexLeft}`}
                                onChange={() =>
                                  setVendorDataRequired(!vendorDataRequired)
                                }
                                checked={vendorDataRequired}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.floatRight} ${style.marginTop10}`}
                          >
                            <button
                              className={`${style.buttonStyle} ${style.marginLeft20}`}
                              onClick={() => handleSave()}
                            >
                              SAVE
                            </button>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={style.spaceBetween}>
              <p className={style.poweredBy}>Powered by - TimeSmartAI.Inc LLP</p>
              <p className={style.poweredBy}>© TimeSmartAI.Inc</p>
            </div>
          </div>
        </div>

        {
          showAddCompanyDialog && (
            <AddMileageRateForCustomer
              getAddMileageRateDialog={getAddMileageRateDialog}
              isEdit={isEdit}
              getMileageRateData={getMileageRateList}
              mileageRateData={mileageRateData}
              selectedYear={selectedYear}
              selectedMileageRate={selectedMileageRate}
            />
          )
        }
        {
          showDeleteConfirmation && (
            <DeleteConfirmation
              getShowDeleteConfirmation={getShowDeleteConfirmation}
              getDeleteConfirmation={getDeleteConfirmation}
              confirmationText="Do you want to delete this holiday?"
            />
          )
        }
      </div>
    </Fragment >
  );
};

export default GeneralConfigurationForCustomers;
